import React, { useState, useEffect } from 'react';
import { Sparkles, MousePointerClick, ArrowRight, Zap, Shield, Palette, CircleArrowOutDownLeft} from 'lucide-react';
import ChatBot from "react-chatbotify";
import PMChatBot from '../chatbot/pm_chatbot';
import { Link } from "react-router-dom";



const WelcomePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const steps = [
    
  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const features = [
    {
      icon: <Sparkles className="w-6 h-6" />,
      title: "Agentic AI System",
      description: (
        <>
        Use autonomous AI agents <br />to identify compatible materials and machines <br />from precision-engineered component properties! 
        </>),
      link: "/agentic-ai"
    },
    {
      icon: <Zap className="w-6 h-6" />,
      title: "RAG Chatbot",
      description: ( <>
      Ask questions and retrieve insights <br />from documents using a knowledge base powered by <br />vector databases & semantic search!</>),
      link: "/rag-chatbot"
    }
  ];

  return (
    <div 
      className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden"
      onMouseMove={handleMouseMove}
    >
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: `radial-gradient(circle 800px at ${mousePosition.x}px ${mousePosition.y}px, rgba(139, 92, 246, 0.3), transparent)`
        }}
      />
      
      <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" />
      <div className="absolute top-40 right-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" />
      <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-12">

        <h1 className={`text-5xl md:text-7xl font-bold text-white text-center mb-6 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="block bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent pb-4">
          Agentic AI & RAG Project Portfolio
          </span>
          
        </h1>

        <p 
        className={`text-lg md:text-2xl text-gray-300 text-center max-w-3xl mb-10 transition-all duration-1000 delay-300  ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        Explore AI solutions built with Agentic AI, RAG, vector databases, and semantic search!
      </p>
   
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {features.map((feature, index) => (
            <Link key={index} to={feature.link} className="group relative">
              <div
                className="group relative bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 hover:bg-white/10 hover:border-purple-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-purple-500/20"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 p-3 bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl text-white group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
                  <p className="text-gray-400">{feature.description}</p>
                  <MousePointerClick 
                    size={35}
                    className="mt-4 text-purple-300 animate-pulse"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 max-w-4xl text-center">
          <p 
            className={`text-sm md:text-base text-gray-400 leading-relaxed text-center max-w-4xl transition-all duration-1000 delay-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            AI-powered proofs of concept demonstrating 
            <span className="text-purple-300 font-medium"> scalable multi-tier architectures, modular design, containerized deployments</span>, and
            <span className="text-purple-300 font-medium"> intelligent data workflows</span>.
          </p>
        </div>
      </div>  

      <div className="w-full max-w-md">
        <PMChatBot steps={steps}/>
      </div>

      {/* ── Bottom-left name credit ── */}
      <div className="fixed bottom-5 left-5 z-50">
        <div
          className="flex items-center gap-2 px-3 py-1.5 rounded-full backdrop-blur-sm transition-all duration-300 hover:scale-105"
          style={{
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 2px 12px rgba(139,92,246,0.15)',
          }}
        >
          <div
            className="w-1.5 h-1.5 rounded-full animate-pulse"
            style={{ background: '#c084fc', boxShadow: '0 0 6px rgba(192,132,252,0.8)' }}
          />
          <span className="text-xs tracking-wide" style={{ color: '#94a3b8' }}>
            crafted by{' '}
            <span
              className="font-semibold"
              style={{
                background: 'linear-gradient(135deg, #c084fc, #f472b6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Veeramanicadas
            </span>
          </span>
        </div>
      </div>

    </div>
  );
};

export default WelcomePage;